<div class="flyout-container" [class.open]="isOpen" [class.fsqs-mode]="hideHistoryPanel" [style.width.%]="currentWidth" #flyout>
    <div class="flyout-content">
        <div class="chat-header">
            <div class="header-content">
                <img src="../../../../assets/images/ai-agent/Ecolab-Virtual-Agent-Logo.svg" />
                <span class="flyout-close" (click)="closeFlyout()">
                    <img class="close-icon" src="../../../../assets/images/fsqs/close-darkblue.svg" />
                </span>
            </div>
        </div>
        <div class="panel-header-container">

            <!-- border-bottom: 2px solid lightgray;" -->
            <div class="header-sub-container">
                <div>
                    <ng-content [select]="panelHeader"></ng-content>
                </div>
                <div  *ngIf="!hideHistoryPanel" class="panel-toggle-button" (click)="toggleRightPanel()">
                    <img *ngIf="!showRightPanel" style="transform: rotateY(180deg);"
                        src="../../../../assets/images/ai-agent/Icon-Navigation.svg" />
                    <img src="../../../../assets/images/ai-agent/Icon-Communication.svg" />
                    <img *ngIf="showRightPanel" src="../../../../assets/images/ai-agent/Icon-Navigation.svg" />
                    <span class="panel-toggle-button-text">{{'AI_AGENT.CHAT_HISTORY' | translate}}</span>
                </div>
            </div>
        </div>


        <div class="flyout-body">
            <div class="split-panels-container">
                <!-- Left Panel -->
                <div class="left-panel" [style.width.%]="leftPanelWidth">
                    <div class="panel-content">
                        <div class="left-panel-content">

                            <!-- Left panel content projection -->
                            <ng-content select="[leftPanel]"></ng-content>
                        </div>
                    </div>
                </div>

                <!-- Right Panel -->
                <div class="right-panel" *ngIf="showRightPanel" [style.width.%]="rightPanelWidth">
                    <div class="panel-content">
                        <div class="right-panel-header">
                            <img src="../../../../assets/images/ai-agent/Icon-Communication-blue.svg" />
                            <span class="ms-2 chat-history">{{'AI_AGENT.CHAT_HISTORY' | translate}}</span>
                        </div>
                        <div class="right-panel-content">
                            <!-- Right panel content projection -->
                            <ng-content select="[rightPanel]" style="height: 100%;"></ng-content>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="resize-handle" #resizeHandle (mousedown)="startResize($event)">
        <div class="resize-indicator"></div>
    </div>
</div>